import { render } from "./ExaminerHelp.vue?vue&type=template&id=4adcb388&scoped=true"
import script from "./ExaminerHelp.vue?vue&type=script&lang=js"
export * from "./ExaminerHelp.vue?vue&type=script&lang=js"

import "./ExaminerHelp.vue?vue&type=style&index=0&id=4adcb388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4adcb388"]])

export default __exports__